var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",staticStyle:{"max-width":"800px","max-height":"400px","position":"relative"}})}
var staticRenderFns = []

export { render, staticRenderFns }